<template>
    <div>
        <le-search-form @reset="handlerRest" @search="handlerSearch" :canPackUp="true" id="leSearch">
            <le-input label="订单编号" v-model="pageParam.params.orderId" />
            <le-date-range 
                label="订单时间" 
                :minDate.sync="pageParam.params.startTime" 
                :maxDate.sync="pageParam.params.endTime" 
                valueFormat="yyyy-MM-dd HH:mm:ss" 
                :defaultTime="['00:00:00','23:59:59']" />
        </le-search-form>
        <le-pagview ref="cardOrderPage" @setData="setTableData" :pageParam="pageParam" :pagerCount="5" :isFixed="true" :tableRef="$refs.cardOrderList">
            <el-table ref="cardOrderList" :data="tableData" :highlight-current-row="true" v-sticky="{ top: 0, parent:'.el-card__body' }" style="width: 100%">
                <el-table-column prop="" label="订单编号" min-width="120">
                    <template slot-scope="{ row }">
                        <span @click="toDetails(row)" class="a-c-blue font-point">{{ row.orderId || '-' }}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="" label="充值消耗" min-width="120">
                    <template slot-scope="{ row }">
                        <span>￥{{ util.numFormat(row.balanceChange) }}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="amount" label="消耗后剩余" min-width="120">
                    <template slot-scope="{ row }">
                        <span>￥{{ util.numFormat(row.afterBalance) }}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="myOrderNum" label="订单类型" min-width="120">
                    <template slot-scope="{ row }">
                        <span >{{ row.orderType | initDic(orderTypeDic) }}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="myOrderNum" label="订单时间" min-width="120">
                    <template slot-scope="{ row }">
                        <span>{{ row.createTime || '-' }}</span>
                    </template>
                </el-table-column>
                <!-- <el-table-column prop="name" label="操作" width="75" fixed="right">
                    <template slot-scope="scope">
                        <el-tooltip class="item" effect="dark" content="编辑" placement="top">
                            <img src="../../assets/icon/option-edit.png" class="a-wh-16" @click="handleEdit(scope.row)" />
                        </el-tooltip>
                    </template>
                </el-table-column> -->
            </el-table>
        </le-pagview>
    </div>
</template>

<script>
    import util from "@/utils/util.js";
    export default {
        data () {
            return {
                tableData: [],
                util: util,
                pageParam: {
                    url: this.$Config.apiUrl.userCardBalancePage,
                    method: "post",
                    params: {
                        "endTime": "",
                        "orderId": "",
                        "startTime": "",
                        "userCardId": this.id
                    },
                    freshCtrl: 1,
                },
                orderTypeDic: []
            }
        },
        props: ['id', 'userId', 'cardBalance'],
        created () {
            this.$getDic('orderType').then(res=>{ this.orderTypeDic = res; })
        },
        methods: {
            setTableData(data) {
                this.tableData = data;
            },
            handlerRest() {
                this.pageParam.params = {
                    "endTime": "",
                    "orderId": "",
                    "startTime": "",
                    "userCardId": this.id
                };
                this.handlerSearch()
            },
            handlerSearch() {
                this.$refs['cardOrderPage'].pageNum = 1
                this.pageParam.freshCtrl++;
            },
            toDetails (datas) {
                if(datas.orderType == 1) {
                    this.$router.push({
                        path:'/order/package-order-info',
                        query: {
                            id: datas?datas.orderId:''
                        }
                    })
                }else if(datas.orderType == 2) {
                    this.$router.push({
                        path: '/order/order-detail',
                        query: {
                            orderId: datas.orderId,
                        }
                    })
                }else if(datas.orderType == 4 || datas.orderType == 5) {
                    this.$router.push({
                        path:'/order/chargeCabinet-order-info',
                        query: {
                            orderSn: datas.orderId,
                            orderId: datas.orderId,
                        }
                    })
                }
                
            }
        }
    }
</script>

<style lang="scss" scoped>
    /deep/ .el-table__body-wrapper::-webkit-scrollbar {
		/*width: 0;宽度为0隐藏*/
		width: 0 !important;
		height: 0 !important;
	}
	/deep/ .el-table__fixed, /deep/ .el-table__fixed-right{
		height: 100% !important;
	}
    /deep/ .companySelect{
        .a-ml-20{
            margin-left: 10px !important;
        }
    }
</style>